import { STATE } from '../util/constants'
import { api } from '../util/mock/index'
export const TOGGLE_WEBCAM = 'scan/TOGGLE_WEBCAM'
export const WEBCAM_LOADED = 'scan/WEBCAM_LOADED'
export const HANDLE_SCAN = 'scan/HANDLE_SCAN'
export const HANDLE_ERROR = 'scan/HANDLE_ERROR'
export const FLIP_WEBCAM = 'scan/FLIP_WEBCAM'
export const STATE_PASS = 'scan/STATE_PASS'
export const STATE_FAIL = 'scan/STATE_FAIL'
const initialState = {
  result: {
    code: "",
    state: STATE.WAITING
  },
  enabled: false,
  loaded: false,
  scanned: false,
  front: false
}
export default (scan = initialState, action) => {
  switch (action.type) {
    case HANDLE_SCAN:
      return {
        ...scan,
        result: {
          code: action.code,
          state: STATE.PENDING
        },
        enabled: false,
        loaded: false,
        scanned: true
      }
    case WEBCAM_LOADED:
      return {
        ...scan,
        loaded: true
      }
    case TOGGLE_WEBCAM:
      return {
        ...scan,
        enabled: !scan.enabled,
        loaded: false
      }
    case FLIP_WEBCAM:
      return {
        ...scan,
        front: !scan.front
      }
    case STATE_PASS:
      return {
        ...scan,
        enabled: false,
        loaded: false,
        scanned: false,
        result: {
          code: scan.result.code,
          state: STATE.PASS
        }
      }
    case STATE_FAIL:
      return {
        ...scan,
        enabled: false,
        loaded: false,
        scanned: false,
        result: {
          code: scan.result.code,
          state: STATE.FAIL
        }
      }
    default:
      return { ...scan }
  }
}

export const toggleWebcam = (e) => {
  return dispatch => {
    dispatch({ type: TOGGLE_WEBCAM })
  }
}
export const webcamLoaded = (e) => {
  return dispatch => {
    dispatch({ type: WEBCAM_LOADED })
  }
}
export const handleScan = (code) => {
  return dispatch => {
    dispatch({ type: HANDLE_SCAN, code });
    api.checkPassCode(code, function (err, pass) {
      if (pass) {
        dispatch({ type: STATE_PASS })
      } else {
        dispatch({ type: STATE_FAIL })
      }
    });
  }
}
export const handleError = (e) => {
  return dispatch => {
    dispatch({ type: HANDLE_ERROR })
  }
}
export const flipWebcam = (e) => {
  return dispatch => {
    dispatch({ type: FLIP_WEBCAM })
  }
}


// WEBPACK FOOTER //
// ./src/reducers/scan.js